module.exports = __webpack_public_path__ + "fonts/787d5a68344eb3e0c6b920d69988f9a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/document.svg
// module id = 2007
// module chunks = 0